import { render, staticRenderFns } from "./GenericCateringWarningOrderModal.vue?vue&type=template&id=90fef408&scoped=true"
import script from "./GenericCateringWarningOrderModal.vue?vue&type=script&lang=ts"
export * from "./GenericCateringWarningOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./GenericCateringWarningOrderModal.vue?vue&type=style&index=0&id=90fef408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fef408",
  null
  
)

export default component.exports